import { Box } from '@dtx-company/design-system/src/components/Box/Box'
import { ElementType, FC, ReactNode } from 'react'
import { SxProps, Theme } from '@mui/system'
import { TypographyVariants } from './HomePageText.types'
import { VARIANT_STYLES_MAP } from './HomePageText.constants'

export type HompepageTextProps = {
  children?: ReactNode
  component?: ElementType
  dangerouslySetInnerHTML?: { __html: string }
  sx?: SxProps<Theme>
  variant: TypographyVariants
}

export const HomePageText: FC<HompepageTextProps> = (props: HompepageTextProps) => {
  const { sx, variant, ...rest } = props
  const variantSxProps = VARIANT_STYLES_MAP[variant]
  return <Box sx={[variantSxProps, ...(Array.isArray(sx) ? sx : [sx])]} {...rest} />
}
